import firebase from "firebase/app";
import "firebase/storage";

export default async (img, appId) => {
  function dec2hex(dec) {
    return ("0" + dec.toString(16)).substr(-2);
  }
  // generateId :: Integer -> String
  function generateId(len) {
    var arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, dec2hex).join("");
  }
  let file= img
  if(!file)return;
  const storageRef = firebase.storage().ref();
  const fileNameParts = file.name.split(".");

  var uploadTask = storageRef
    .child(appId + '/' + generateId(15) + "." + fileNameParts[fileNameParts.length - 1])
    .put(file);

    return uploadTask.
    then(snapshot => {
      const imageUrl = snapshot.ref.getDownloadURL()
      return imageUrl;
    })
    .then((url) => {
      return url
    });
}